import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FacturaReadingFiltersDtoProps } from "api/DTOs/FacturaReadingFiltersDto"
import { ESTADO_REVISION_DOCUMENTO_COMERCIAL } from "api/Types/EstadoRevisionDocumentoComercial"
import { ESTADOS_COBRO } from "api/Types/EstadosCobro"
import { ESTADOS_PAGO } from "api/Types/EstadosPago"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"

type EstadoProperties = {
  className: string
  text: string
  icon: IconName
}

export const EstadoCobroPagoFactura = ({
  rowData,
  isVenta,
  t,
}: {
  rowData: FacturaReadingFiltersDtoProps
  isVenta: boolean
  t: TFunction
}) => {
  const getEstadoCobroPago = (): EstadoProperties | undefined => {
    if (isVenta) {
      switch (rowData.estadoCobro) {
        case ESTADOS_COBRO.COBRADO:
          return {
            className: "tw-text-success",
            text: t("crear.factura.tab.statusPayCobrar"),
            icon: "check",
          }
        case ESTADOS_COBRO.NO_COBRADO:
          return {
            className: "tw-text-warning",
            text: t("crear.factura.tab.statusPend"),
            icon: "clock",
          }
        case ESTADOS_COBRO.PARCIALMENTE_COBRADA:
          return {
            className: "tw-text-warning",
            text: t("crear.factura.tab.statusParcialCobrar"),
            icon: "clock",
          }
        default:
          return undefined
      }
    } else {
      switch (rowData.estadoPago) {
        case ESTADOS_PAGO.PAGADA:
          return {
            className: "tw-text-success",
            text: t("crear.factura.tab.statusPayPagar"),
            icon: "check",
          }
        case ESTADOS_PAGO.NO_PAGADO:
          return {
            className: "tw-text-warning",
            text: t("crear.factura.tab.statusPend"),
            icon: "clock",
          }
        case ESTADOS_PAGO.PARCIALMENTE_PAGADA:
          return {
            className: "tw-text-warning",
            text: t("crear.factura.tab.statusParcialPago"),
            icon: "clock",
          }
        default:
          return undefined
      }
    }
  }

  const estadoCobroPago = getEstadoCobroPago()

  return estadoCobroPago &&
    rowData?.estadoRevisionActual !==
      ESTADO_REVISION_DOCUMENTO_COMERCIAL.BORRADOR ? (
    <div className='tw-flex tw-flex-col tw-items-end tw-justify-center'>
      <span
        className={`tw-flex tw-items-center tw-w-fit tw-gap-1.5 ${estadoCobroPago.className}`}
      >
        <FontAwesomeIcon
          icon={["fal", estadoCobroPago.icon]}
          className='tw-h-4'
        />
        <span className='tw-w-fit tw-whitespace-normal tw-break-words'>
          {estadoCobroPago.text}
        </span>
      </span>
      {(isVenta
        ? rowData.estadoCobro !== ESTADOS_COBRO.COBRADO
        : rowData.estadoPago !== ESTADOS_PAGO.PAGADA) && (
        <span>{formatCurrency(rowData.importePendiente ?? 0)}</span>
      )}
    </div>
  ) : (
    <p className='tw-text-end'>-</p>
  )
}
